// Foodoor's business day is the UTC day: 00:00 UTC is 05:30 IST, the moment the
// service reopens, so a night shift is never split across two "days". The IST
// midnight boundary would cut it in half.
export const isSameBusinessDay = (value, now = new Date()) => {
  if (!value) return false;
  const date = value instanceof Date ? value : new Date(value);
  const today = now instanceof Date ? now : new Date(now);
  if (Number.isNaN(date.getTime()) || Number.isNaN(today.getTime())) return false;
  return (
    date.getUTCFullYear() === today.getUTCFullYear() &&
    date.getUTCMonth() === today.getUTCMonth() &&
    date.getUTCDate() === today.getUTCDate()
  );
};

export const customerDetailsVisible = ({ isPrivileged, isStaff }) =>
  Boolean(isPrivileged || isStaff);
